<span class="relative flex flex-col w-full h-full">
    <div class="absolute top-0 right-0 pt-4 pr-4">
        <button mat-icon-button [matTooltip]="'Útskrá'" (click)="lokaClick()">
            <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <div mat-dialog-content>
        <auth-sign-in [isDialog]="'true'"></auth-sign-in>
    </div>
</span>
